module.exports = __webpack_public_path__ + "static/media/Pradeep Kumar Jayaraman.8ba8298b.png";